<template>
	<div>
		<nav class="navbar navbar-expand-xl navbar-light bg-light" aria-label="Sixth navbar example">
			<div class="container-fluid">
				<a class="navbar-brand cursor-pointer">
					<img src="@/assets/style/image/logo_horizontal.png" alt="Logo" style="width: 140px;" class="">
				</a>
			
				<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample06" aria-controls="navbarsExample06" aria-expanded="false" aria-label="Toggle navigation" >
					<span class="navbar-toggler-icon"></span>
				</button>

				<div class="collapse navbar-collapse" id="navbarsExample06">

					<CNavLinks :pArrayMenus="ArrayMenu" :pMenus="ListMenus" :pSubMenus="ListSubMenus" :pApartados="ListApartados" :pVerMenu="VerMenu">
						<template slot="MenuDerecho">
						</template>
					</CNavLinks>

					<ul class="navbar-nav justify-content-end">
						<li class="nav-item dropdown d-flex align-items-center px-3">
							<a class="nav-link dropdown-toggle text-black font-weight-bold px-0 cursor-pointer" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
								<img class="rounded-circle w-25 position-absolute ml-1" alt="Imagen" v-if="this.ObjUsuario.Imagen == ''" src="@/assets/style/image/team-4.jpg" />
								<img class="rounded-circle w-25 position-absolute ml-1" alt="Imagen" v-else :src="this.RutaFile"/>
								<span class="d-sm-inline d-none"> {{ this.ObjUsuario.username }}</span>
							</a>

							<ul class="dropdown-menu dropdown-menu-end px-2 py-3 me-sm-n4" aria-labelledby="dropdownMenuButton2">
								<li class="mb-2">
									<a class="dropdown-item border-radius-md">
										<div class="d-flex py-1">
											<div class="my-auto">
												<img class="avatar avatar-sm bg-gradient-dark  me-3" alt="Imagen" v-if="this.ObjUsuario.Imagen == ''" src="@/assets/style/image/team-4.jpg" >

												<img class="avatar avatar-sm bg-gradient-dark  me-3" alt="Imagen" v-else :src="this.RutaFile">
											</div>

											<div class="d-flex flex-column justify-content-center">
												<h6 class="text-sm font-weight-normal mb-1" @click="MiPerfil(0)">
													<span class="font-weight-bold">Mi Perfil</span>
												</h6>
											</div>
										</div>
									</a>
								</li>

								<li>
									<a class="dropdown-item border-radius-md" @click="CerrarSession()">
										<div class="d-flex py-1">
											<div class="avatar avatar-sm bg-gradient-secondary  me-3  my-auto">
												<i class="fas fa-sign-out-alt"></i>
											</div>

											<div class="d-flex flex-column justify-content-center">
												<h6 class="text-sm font-weight-normal mb-1" >
													<span class="font-weight-bold">Salir</span>
												</h6>
											</div>
										</div>
									</a>
								</li>
							</ul>
						</li>
						<Notificacion></Notificacion>
					</ul>
				</div>
			</div>
		</nav>
		
		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<FormMiPerfil :poBtnSave="oBtnSave"></FormMiPerfil>
			</template>
		</CModal>

		<CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
			<template slot="Form">
				<FormCambiarPassword :poBtnSave="oBtnSave2"></FormCambiarPassword>
			</template>
		</CModal>

	</div>
</template>

<script>

import MenusConfiguracion  from '@/config/ConfigMenu.js';
import Configs 			   from '@/helpers/VarConfig.js';
import FormMiPerfil		   from '@/views/segurity/MiPerfil.vue';
import FormCambiarPassword from '@/views/segurity/CambiarPassword.vue';
import Notificacion from '@/views/template/Notificacion.vue';
const EmitEjecuta 		   =    'FormMiPerfil';
const EmitEjecuta2		   =    'FormCambiarPassword';

export default {
	name:  'NavLinks',
	props: [''],
	components: {FormMiPerfil,FormCambiarPassword,Notificacion },
	data() {
		return {				
			RutaFile: 	  "",
			valSearch: 	  '',
			isVisible:	  false,
			ArrayMenu: 	  MenusConfiguracion.ConfigMenus,
			ArrayMenuDer: MenusConfiguracion.ConfigMenuDer,
			ObjUsuario:   {},
			IsEmpleado:   false,
			IsRoot: 	  false,
			loading: 	  false,
			ConfigModal:{
				ModalTitle:  "Mi Perfil",
				ModalSize:   'lg',
				ModalNameId: 'ModalForm2',
				EmitSeccion:  EmitEjecuta,
			},
			oBtnSave: {
				toast:       0,
				IsModal:     true,
				DisableBtn:  false,
				EmitSeccion: EmitEjecuta,
			},
			ConfigModal2:{				
				ModalTitle:  "Cambiar Contraseña",
				ModalSize:   'lg',
				ModalNameId: 'ModalForm',
				EmitSeccion:  EmitEjecuta2,
			},
			oBtnSave2: {
				toast:       0,
				IsModal:     true,
				DisableBtn:  false,
				EmitSeccion: EmitEjecuta2,
			},
			ListMenus: [],
			ListSubMenus: [],
			ListApartados: [],
			ListSubApartado: [],
			ListBusquedaLigada: [],
			VerMenu: 0,
		}
	},
	methods: {
		Session() {
			this.ObjUsuario = JSON.parse(sessionStorage.getItem("user"));
			this.RutaFile 	= sessionStorage.getItem('RutaFile')+this.ObjUsuario.Imagen;

			if (this.ObjUsuario != null) {

				if (this.ObjUsuario.IdPerfil > 0) {
					this.IsEmpleado = true;
				} else if (this.ObjUsuario.IdPerfil == 0) {
					this.IsRoot = true;
				}
				this.VerificarPermisos();
			}
		},
		CerrarSession(){
			this.$swal(Configs.configCerrarSession).then((result) => {
				
				if(result.value) {
					this.$store.dispatch("logout");
					this.$router.push({ name: "login" });
				} 
			});
		},
		MiPerfil() {
			this.bus.$emit('NewModal_'+EmitEjecuta,this.ObjUsuario.IdUsuario);
		},	
		CambiarPassword() {
			this.bus.$emit('NewModal_'+EmitEjecuta2,this.ObjUsuario.IdUsuario);
		},
		Ir_a_inicio() {
			this.$router.push({name:'inicio',params:{}});
		},		
		Ir_a_empleados() {
			this.$router.push({name:'empleados',params:{}});
		},    
		Substraer(Nombre){
			let name = '';

			if (Nombre != null && Nombre != ''){
				name = Nombre.substr(0,17);
			}

			return name;
		},
		VerificarPermisos() {
			this.$http.get('panelmenugetmenus',{}
			).then((res) => {
				this.ListMenus = res.data.Menus;
				this.ListSubMenus = res.data.SubMenus;
				this.ListApartados = res.data.Apartados;
				this.ListSubApartado = res.data.SubApartados;

				let Menus = {
					Menus: this.ListMenus,
					SubMenus: this.ListSubMenus,
					Apartados: this.ListApartados,
					SubApartados: this.ListSubApartado,
				}
				sessionStorage.setItem('ObjMenus',JSON.stringify(Menus));
				this.VerMenu = res.data.VerMenu;         
			});
		},
	},
	created() {
		this.Session();
	},
}
</script>
<style>
.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(43, 41, 132, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

.navbar-light .navbar-toggler {
    border: solid !important; 
    border-width: 0.1em !important;
    border-color: #ddd8d8 !important;
}
</style>